<form [formGroup]="form" (keydown.enter)="onEnter($event)">
  <div class="filter-box">
    <div class="filter-header pb-3">
      <div class="group-title">
        <div [class]="config.iconName"></div>
        <div>{{ config.title | translate }}</div>
        <button mat-icon-button (click)="onReload()">
          <span class="reload"></span>
        </button>
      </div>
      <div class="group-actions">
        <div
          class="item location"
          *ngIf="config.locations && config.locations.length > 1"
        >
          <ng-select
            notFoundText="{{ 'No items found' | translate }}"
            [items]="config.locations"
            bindLabel="name"
            bindValue="id"
            [searchable]="true"
            [clearable]="false"
            formControlName="location_id"
            (change)="onLocationChanged($event)"
          >
          </ng-select>
        </div>
      </div>
    </div>
    <div class="filter-form mt-3">
      <div class="row">
        <div
          [class.col-md-2]="
            isJourneySearch ||
            isJourneyReport ||
            isLoading ||
            isOnLoading ||
            isWeighbridge ||
            isReportMaster ||
            isVessel ||
            isEntry ||
            isEntryIn ||
            isEntryOut ||
            isCargo
          "
          [class.col-md-3]="
            !(
              isJourneySearch ||
              isJourneyReport ||
              isLoading ||
              isOnLoading ||
              isWeighbridge ||
              isReportMaster ||
              isVessel ||
              isEntry ||
              isEntryIn ||
              isEntryOut ||
              isCargo
            )
          "
          *ngIf="!isAlertNoti && !isFleet"
        >
          <div class="form-group">
            <label for="">{{ "STATUS" | translate }}</label>
            <ng-select
              notFoundText="{{ 'No items found' | translate }}"
              [items]="config?.status"
              bindLabel="label"
              bindValue="value"
              placeholder="{{ '(All Status)' | translate }}"
              [searchable]="false"
              formControlName="status"
              (change)="onValueChanged($event)"
            >
            </ng-select>
          </div>
        </div>

        <div class="col-md-2" *ngIf="!isJourneySearch">
          <label>{{ "FROM" | translate }}</label>
          <div class="form-group date-with-clear">
            <app-date-time-picker
              formControlName="from"
              placeholder="      /      /      "
              [config]="fromDateConfigOptions"
              #startDate
            ></app-date-time-picker>
            <button
              *ngIf="hasFromDate"
              class="clear-date-btn"
              (click)="clearDate('from')"
              mat-icon-button
              type="button"
            >
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>

        <!-- TO DATE -->
        <div class="col-md-2" *ngIf="!isJourneySearch">
          <label for="">{{ "TO" | translate }}</label>
          <div class="form-group date-with-clear">
            <app-date-time-picker
              formControlName="until"
              placeholder="      /      /      "
              [config]="toDateConfigOptions"
              #endDate
            ></app-date-time-picker>
            <button
              *ngIf="hasToDate"
              class="clear-date-btn"
              (click)="clearDate('until')"
              mat-icon-button
              type="button"
            >
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>

        <div class="col-md-2" *ngIf="isVessel || isCargo">
          <div class="form-group">
            <label for="">{{ "TYPE" | translate }}</label>
            <ng-select
              notFoundText="{{ 'No items found' | translate }}"
              [items]="config?.typeAction"
              bindLabel="label"
              bindValue="value"
              placeholder="{{ 'All' | translate }}"
              [searchable]="false"
              [clearable]="false"
              formControlName="type"
              (change)="onTypeChanged($event)"
            >
            </ng-select>
          </div>
        </div>
        <div
          class="col-md-2"
          [class.col-md-2]="
            !(
              isLoading ||
              isWeighbridge ||
              isOnLoading ||
              isEntry ||
              isEntryIn ||
              isEntryOut
            )
          "
          [class.col-md-3]="
            isLoading ||
            isWeighbridge ||
            isOnLoading ||
            isEntry ||
            isEntryIn ||
            isEntryOut
          "
          *ngIf="
            isJourneySearch ||
            isJourneyReport ||
            isDocuments ||
            isJourney ||
            isLoading ||
            isWeighbridge ||
            isReportMaster ||
            isVessel ||
            isLifts ||
            isOnLoading ||
            isEntry ||
            isEntryIn ||
            isEntryOut ||
            isReheating ||
            isEir ||
            isCargo ||
            isDGD
          "
        >
          <div class="form-group">
            <label for="">{{ "SEARCH" | translate }}</label>
            <ng-select
              notFoundText="{{ 'No items found' | translate }}"
              [items]="config?.types"
              bindLabel="label"
              bindValue="value"
              placeholder="{{ 'Type' | translate }}"
              [searchable]="false"
              [clearable]="false"
              formControlName="search_type"
              (change)="onSearchTypeChanged($event)"
            >
            </ng-select>
          </div>
        </div>
        <div
          class="col"
          [class.group-export]="isJourneyReport || isReportMaster"
          *ngIf="!isAlertNoti"
        >
          <div class="form-group w-full">
            <label
              for=""
              [class.visi-hide]="
                isJourneySearch ||
                isJourneyReport ||
                isDocuments ||
                isJourney ||
                isLoading ||
                isWeighbridge ||
                isReportMaster ||
                isVessel ||
                isLifts ||
                isOnLoading ||
                isEntry ||
                isEntryIn ||
                isEntryOut ||
                isReheating ||
                isEir ||
                isCargo ||
                isDGD
              "
              >{{ "SEARCH" | translate }}</label
            >
            <div class="search">
              <input
                appSearch
                (search)="onSearch()"
                (input)="onSearchInput($event)"
                type="text"
                formControlName="search"
                class="form-control"
                placeholder="{{
                  config?.searchPlaceholder || 'Search' | translate
                }}"
              />
              <div class="search-icon"></div>
            </div>
          </div>
          <div
            class="btn btn-primary btn-export"
            (click)="onExport()"
            *ngIf="isJourneyReport || isReportMaster"
          >
            <div *ngIf="exporting" class="spinner-border" role="status"></div>
            <span *ngIf="!exporting">{{ "Export" | translate }}</span>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="isLifts">
        <div class="col-md-3">
          <div class="form-group">
            <label for="">{{ "CATEGORY" | translate }}</label>
            <ng-select
              notFoundText="{{ 'No items found' | translate }}"
              [items]="config?.type"
              bindLabel="label"
              bindValue="value"
              placeholder="{{ 'All' | translate }}"
              [searchable]="false"
              formControlName="type"
              (change)="onValueCategoryChanged($event)"
            >
            </ng-select>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="isWeighbridge">
        <div class="col-md-3">
          <div class="form-group">
            <label for="">{{ "CATEGORY" | translate }}</label>
            <ng-select
              notFoundText="{{ 'No items found' | translate }}"
              [items]="config?.categories"
              bindLabel="label"
              bindValue="value"
              placeholder="{{ 'All' | translate }}"
              [searchable]="false"
              formControlName="category"
              (change)="onValueCategoryChanged($event)"
            >
            </ng-select>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
